import { render, staticRenderFns } from "./LanguageColumn.vue?vue&type=template&id=1cb5b75d&scoped=true&lang=html&"
import script from "./LanguageColumn.vue?vue&type=script&lang=js&"
export * from "./LanguageColumn.vue?vue&type=script&lang=js&"
import style0 from "./LanguageColumn.vue?vue&type=style&index=0&id=1cb5b75d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5b75d",
  null
  
)

export default component.exports